document.addEventListener("DOMContentLoaded", () => {

    gsap.registerPlugin(ScrollTrigger, MotionPathPlugin);
  
    const steps = gsap.utils.toArray('.wls-routine-steps__slider-number');
    const contents = gsap.utils.toArray('.wls-routine-steps__slider-content-item');
    const total = steps.length;
  
    if (!steps.length) return;

    steps.forEach((step, i) => step.classList.toggle('active', i === 0));
    contents.forEach((c, i) => c.classList.toggle('active', i === 0));
  
    function getArcPathSelector() {
      return window.innerWidth <= 1199 ? '#arcPathMobile' : '#arcPath';
    }
  
    function animateSteps() {
  
      ScrollTrigger.getAll().forEach(st => st.kill());
      gsap.killTweensOf(steps);
  
      gsap.to(steps, {
        motionPath: {
          path: getArcPathSelector(),
          align: getArcPathSelector(),
          alignOrigin: [0.5, 0.5],
          autoRotate: false,
          start: 1,
          end: 0
        },
        ease: "none",
        stagger: {
          each: 0.5 / (total - 1),
          from: 0
        },
        scrollTrigger: {
          trigger: ".wls-routine-steps__slider",
          start: "top top",
          end: "+=800",
          scrub: 0.5,
          pin: true,
          onUpdate: self => {
            const index = Math.min(total - 1, Math.floor(self.progress * total));
  
            steps.forEach((step, i) => {
              step.classList.toggle('active', i === index);
              step.classList.toggle('prev', i === index - 1);
              step.classList.toggle('next', i === index + 1);
            });
  
            contents.forEach((c, i) =>
              c.classList.toggle('active', i === index)
            );
          }
        }
      });
    }
  
    animateSteps();
  
    window.addEventListener('resize', gsap.utils.debounce(animateSteps, 200));
  
});

document.addEventListener("DOMContentLoaded", () => {

  function setEqualHeight() {
    const items = document.querySelectorAll('.wls-routine-steps__slider-content-item-desc');
      if (!items.length) return;

      items.forEach(item => item.style.height = 'auto');

      let maxHeight = 0;
      items.forEach(item => {
        const h = item.offsetHeight;
        if (h > maxHeight) maxHeight = h;
      });

      items.forEach(item => item.style.height = maxHeight + 'px');
  }

  window.addEventListener('DOMContentLoaded', setEqualHeight);
  window.addEventListener('resize', gsap.utils.debounce(setEqualHeight, 200));
});